module.exports = __webpack_public_path__ + "img/symbol_6.a7fa5cda.png";